import React from "react";
import Cloud from "./Cloud";
import Rain from "./Rain";
import Suncloud from "./Suncloud";
import Sun from "./Sun";
import Thunder from "./Thunder";
import Thundercloud from "./Thundercloud";
import Thunderrain from "./Thunderrain";
import dayjs from "dayjs";
import Weekweather from "./Weekweather";
import Thundersun from "./Thundersun";
import Weektemperature from "./Weektemperature";
import Weekuvindex from "./Weekuvindex";
import Moon from "./Moon";
import Mooncloud from "./Mooncloud";
import Moonrain from "./Moonrain";
import Thundermoon from "./Thundermoon";

const Weather = ({ data, city }) => {
  let weathercode = data[12].Time[0].ElementValue[0].WeatherCode;
  let Weekweathers = data[12].Time;
  let Weekweathertemperatures = data[0].Time;
  let weekuvindex = data[13].Time;
  let currenttime = data[12].Time[0].StartTime;
  const hour = new Date(currenttime).getHours();
  const isDay = hour === 6 || hour === 12;
  return (
    <div className="weatherbg">
      <div className="weatherbox">
        <div className="left">
          <div className="top-in-left">
            <div className="left-in-lefttop">
              <p className="temperature">
                {data[0].Time[0].ElementValue[0].Temperature}˚C
              </p>
              <h3 className="city">{city}</h3>
              <p className="date">
                {dayjs(data[0].Time[0].StartTime).format("M月D日 HH:mm")}
              </p>
              <p className="precipitation">
                降雨機率
                {data[11].Time[0].ElementValue[0].ProbabilityOfPrecipitation}%
              </p>
            </div>

            <div className="right-in-lefttop">
              <div className="iconbox">
                {/* debug用 */}
                {/* <Mooncloud className="mooncloud-in-weather" /> */}
                {/* <Moonrain className="moonrain-in-weather" /> */}
                {/* <Sun className="sun-in-weather" /> */}
                {/* <Thunderrain className="thunderrain-in-weather" /> */}
                {/* <Thundersun className="thundersun-in-weather" /> */}
                {/* <Moonrain className="moonrain-in-weather" /> */}
                {/* <Mooncloud className="mooncloud-in-weather" /> */}
                {/* <Thundermoon className="thundermoon-in-weather" /> */}

                {/* 實際使用 */}
                {weathercode == "01" &&
                  (isDay ? (
                    <Sun className="sun-in-weather" />
                  ) : (
                    <Moon className="moon-in-weather" />
                  ))}
                {["02", "03"].includes(weathercode) &&
                  (isDay ? (
                    <Suncloud className="suncloud-in-weather" />
                  ) : (
                    <Mooncloud className="mooncloud-in-weather" />
                  ))}
                {["04", "05", "06", "07"].includes(weathercode) &&
                  (isDay ? (
                    <Cloud className="cloud-in-weather" />
                  ) : (
                    <Cloud className="nightcloud-in-weather" />
                  ))}
                {[
                  "08",
                  "09",
                  "10",
                  "11",
                  "12",
                  "13",
                  "14",
                  "29",
                  "30",
                ].includes(weathercode) &&
                  (isDay ? (
                    <Rain className="rain-in-weather" />
                  ) : (
                    <Rain className="nightrain-in-weather" />
                  ))}
                {["15", "16", "17", "18", "22", "33", "34"].includes(
                  weathercode
                ) && <Thunderrain className="thunderrain-in-weather" />}
                {["21"].includes(weathercode) &&
                  (isDay ? (
                    <Thundersun className="thundersun-in-weather" />
                  ) : (
                    <Thundermoon className="thundermoon-in-weather" />
                  ))}
              </div>
              <h6 className="overview">
                {data[12].Time[0].ElementValue[0].Weather}
              </h6>
            </div>
          </div>

          <div className="bottom-in-left">
            <h6 className="tip">
              {data[14].Time[0].ElementValue[0].WeatherDescription}
            </h6>
          </div>
        </div>

        <div className="right">
          <label htmlFor="switch">
            <input id="switch" type="checkbox" />
            <div className="topbox">
              <h6>一週平均氣溫(白天)</h6>
              <Weektemperature
                className="wt"
                Weekweathertemperatures={Weekweathertemperatures}
              />
            </div>
            <div className="bottombox">
              <h6>一週天氣概況(白天)</h6>
              <Weekweather className="ww" Weekweathers={Weekweathers} />
            </div>
            <div className="wholebox">
              <h6>一週紫外線指數(白天)</h6>
              <Weekuvindex className="wu" weekuvindex={weekuvindex} />
            </div>
          </label>
        </div>
        <div className="arrow"></div>
      </div>
    </div>
  );
};

export default Weather;
